



































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { getLandmarkPeriodsInformation, getCmsHomeFirstPage } from "@/axios";
import { Col } from "element-ui";
import { ElStep } from "element-ui/types/step";

declare let $: any; // ts引用第三方插件写法

@Component({
  name: "homePage",
})
export default class extends Vue {
  @Prop()
  inputPageHomeData: any;

  @Watch("inputPageHomeData", { immediate: true, deep: true })
  oninputPageHomeData(val: any, oldVal: any) {
    console.log("oninputPageHomeData=========", val);

    this.pageHomeData = val;
    this.designatedArticleListData = val.designatedArticleList;
    this.eightBlessingsData = val.eightBlessingsData;
    this.selectedList = val.stageNum;

    this.$nextTick(() => {
      this.leftValue = $(".goods-list")
        .eq(0)
        .outerWidth(true);
      clearInterval(this.loop);
      this.loop = setInterval(() => {
        this.loopHandle();
      }, 40);
    });
  }

  /**组件销毁前执行
   * @param {*}
   * @return {*}
   * @author: hejianwei
   * @Date: 2021-12-22 16:20:21
   */
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    $(window).scrollTop(0);
  }

  private searchBarFixed: any = true;
  private detail: any = "";
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }

  private addListscroll() {
    window.addEventListener("scroll", this.handleScroll);
    this.firstEnter = false;
    this.scrollCount = 0;

    $(window).scrollTop(0);

    setTimeout(() => {
      this.firstEnter = true;
      this.searchBarFixed = true;
    }, 200);
  }
  private RemoveList() {
    window.removeEventListener("scroll", this.handleScroll);
    $(window).scrollTop(0);
  }

  private scrollState: any = true;
  private scrollCount: any = 0;
  private scrollTime: any = null;
  private firstEnter: any = true;

  /**滚动监听事件
   * @param {*}
   * @return {*}
   * @author: hejianwei
   * @Date: 2021-12-07 16:46:29
   */
  private handleScroll() {
    if (
      $(window).scrollTop() <= 0 &&
      this.scrollCount == 1 &&
      !this.searchBarFixed
    ) {
      this.searchBarFixed = true;
      this.scrollState = true;
      this.scrollCount = 0;
      clearTimeout(this.scrollTime);
      console.log("到顶部");
      return false;
    }
    if (this.scrollState && this.firstEnter) {
      this.scrollState = false;
      this.scrollTime = setTimeout(() => {
        this.scrollState = true;
        this.scrollCount = 1;
      }, 1000);
      this.searchBarFixed = false;
      console.log("11111111", this.scrollCount);
      return false;
    }
    if (!this.scrollState && this.scrollCount == 0) {
      $(window).scrollTop(1);
      console.log("向下滚动");
      // console;
    }
  }

  private loopHandle() {
    var val = $(".goods-list")
      .eq(0)
      .outerWidth(true);
    this.leftValue++;
    if (this.leftValue >= val * 2) {
      this.leftValue = val;
    }
  }

  private tabSelectedItemIndex(index: any) {
    if (this.selectedItemIndex == index) {
      return false;
    }
    this.selectedItemIndex = index;

    console.log(this.pageHomeData.recommendLandmarkData);

    getLandmarkPeriodsInformation({
      time_group_id: this.selectedItemIndex,
    }).then((res: any) => {
      console.log(
        "getLandmarkPeriodsInformation-----",
        res.data.data.recommendLandmarkData
      );

      this.pageHomeData.recommendLandmarkData =
        res.data.data.recommendLandmarkData;

      this.landmarkIndex = 0;
      this.landmarkArtucleIndex = 0;

      this.$nextTick(() => {
        this.leftValue = $(".goods-list")
          .eq(0)
          .outerWidth(true);
        clearInterval(this.loop);
        this.loop = setInterval(() => {
          this.loopHandle();
        }, 40);
      });
    });
  }

  private selectedItemIndex: any = 1;

  private selectedList: any = [
    // {
    //   name: '全部',
    //   id: 0
    // },
    // {
    //   name: "第一期",
    //   id: 1,
    // },
    // {
    //   name: "第二期",
    //   id: 2,
    // },
    // {
    //   name: "第三期",
    //   id: 3,
    // },
    // {
    //   name: "第四期",
    //   id: 4,
    // },
  ];

  private loop: any = null;
  private leftValue: any = 0;

  private dialogShow: any = false;
  private videoUrl: any = "";

  private vrdialogShow: any = false;
  private vrUrl: any = "";

  // 顶部右侧地标资讯显示的数据
  private designatedArticleListData: any = [];
  //八福图片
  private eightBlessingsData: any = [];
  // 底部地标索引
  private landmarkIndex: any = 0;
  // 底部地标文章索引
  private landmarkArtucleIndex: any = 0;
  private videoIndex: any = 0;
  private videoItemList: any = [];
  // 首页数据
  private pageHomeData: any = {
    // 顶部轮播
    rotationPictureData: [],
    // 顶部四大图
    recommendPictureData: [],
    // 顶部右侧地标资讯
    designatedArticleList: [],
    // 底部地标数据
    recommendLandmarkData: [],
    // 8福
    eightBlessingsData: [],
  };

  private goLandmarkIndex(ev: any, id: any) {
    // alert(this.noMove)

    console.log("goLandmarkIndex--ev", ev);
    console.log("this.disX=========", this.disOldX);

    if (ev.clientX != this.disOldX) {
      return false;
    }

    this.$router.push({
      path: "/landmarkIndex",
      query: { landmarkId: id },
    });
  }

  private goArticle() {
    this.$router.push("/article");
  }

  private tabLandmarkArtucleIndex(index: any) {
    this.landmarkArtucleIndex = index;
  }

  private tabLandmarkIndexIndex(index: any) {
    this.landmarkIndex = index;
    clearInterval(this.loop);
  }

  private disX: any = "";
  private disY: any = "";
  private noMove: any = true;
  private leftValueTemp: any = 0;

  private disOldX: any = "";

  private mousedownHandle(event: any) {
    this.disX = event.clientX;
    this.disY = event.clientY;
    this.leftValueTemp = this.leftValue;

    this.disOldX = event.clientX;
  }

  private mousemoveHandle(event: any) {
    if (this.disX == "" || this.disY == "") {
      return false;
    }

    this.noMove = false;
    var moveX = this.disX - event.clientX;
    var currentX = this.leftValueTemp + moveX;
    var val = $(".goods-list")
      .eq(0)
      .outerWidth(true);

    if (currentX >= val * 2) {
      currentX = val;
      this.leftValueTemp = val;
      this.disX = event.clientX;
      this.disY = event.clientY;
      // console.log('触发',currentX)
    }

    this.leftValue = currentX;
  }

  private mouseleaveHandle() {
    var val = $(".goods-list")
      .eq(0)
      .outerWidth(true);
    clearInterval(this.loop);
    this.loop = setInterval(() => {
      this.loopHandle();
    }, 30);

    this.disX = "";
    this.disY = "";

    if (val > this.leftValue) {
      this.leftValue = val + this.leftValue;
    }
  }

  private toArticleList(id: any, item: any = null) {
    if (item != null) {
      // console.log('item----',item.name)
      if (item.name == "智慧展示" || item.name == "宣传视频") {
        return false;
      } else {
        this.$router.push({
          name: "Article",
          query: {
            type: "0",
            id,
          },
        });
      }
    } else {
      this.$router.push({
        name: "Article",
        query: {
          type: "0",
          id,
        },
      });
    }
  }

  private showVideo(url: any, itemList: any) {
    this.videoUrl = url;
    this.dialogShow = true;
    this.videoItemList = itemList;
  }
  private moveIndex: any = -1;

  //鼠标移入效果
  private mouseoverIndex(index: any) {
    this.moveIndex = index;
    // alert(index);
  }
  //鼠标移出效果
  private mouseleaveIndex() {
    this.moveIndex = -1;
  }
  private videoEnd() {
    console.log(this.videoItemList);
    if (this.videoIndex < this.videoItemList.video_list.length) {
      this.videoIndex++;
    } else {
      this.videoIndex = 0;
    }
    this.videoUrl = this.videoItemList.video_list[this.videoIndex];
    (this as any).$refs.video.play();
  }

  private showVr(url: any) {
    this.vrUrl = url;
    this.vrdialogShow = true;
    // console.log(url)
  }

  private toDetail(item: any) {
    this.$router.push({
      name: "Article",
      query: {
        type: "1",
        landmarkId: item.landmark_id,
        id: item.id,
      },
    });
  }
}
